<div class="redirect-page-wrapper">
    <div class="redirect-page-inner">
        <div class="redirect-page-logo">
            <img src="assets/layout/images/champ.jpg" alt="Sakai logo" class="mb-4 w-6rem flex-shrink-0">
        </div>
        <div class="redirect-page-content">
                <div class="redirect-content-title">
                    <i class="pi pi-times-circle redirect-page-icon"></i>
                    <span class="redirect-title-text">Payment failed</span>
            </div>
            <div class="redirect-page-body">
                <img class="failure-picture" src="assets/demo/images/payment_failed.png" alt="Error" class="mb-5" width="80%">
            </div>
        </div>
    </div>
</div>
